export const devConfig = {
    backendUrl: 'https://api-dev.synswi.com',
    localStorageKey: 'onboarding',
    tokenizationBaseUrl: "https://tokenization-form-dev.synswi.com",
    documentationUrl: "https://docs.synswi.com",
    mode: "dev"
}

export const prodConfig = {
    backendUrl: 'https://api.synswi.com',
    localStorageKey: 'onboarding',
    tokenizationBaseUrl: "https://tokenization-form.synswi.com",
    documentationUrl: "https://docs.synswi.com",
    mode: "dev"
}

export const sandboxConfig = {
    backendUrl: 'https://api-sandbox.synswi.com',
    localStorageKey: 'onboarding',
    tokenizationBaseUrl: "https://tokenization-form-sandbox.synswi.com",
    documentationUrl: "https://docs.synswi.com",
    mode: "dev"
}

const env = import.meta.env.VITE_ENV
console.log('env', env)
export const config = env === 'prod' ? prodConfig : env === 'sandbox' ? sandboxConfig : devConfig